import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalanceEmailTemplate.Delete.IRequest;
type Response = Api.Core.StatementBalanceEmailTemplate.Delete.IResponse;
type Headers = Api.Core.StatementBalanceEmailTemplate.Delete.IHeaders;
const url = '/api/Management/StatementBalanceEmailTemplate/:id';
export default async function statementBalanceEmailTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
